import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { PriceService } from '../../../services/PriceService';
import { GetPriceListPagingAndFilterRequest, initialGetPriceListPagingAndFilterRequest } from '../../../models/request/price/GetPriceListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetPriceListPagingAndFilterResponse, GetPriceListPagingAndFilterResponseData, GetPriceListPagingAndFilterResponseItem, initialGetPriceListPagingAndFilterResponseData } from '../../../models/response/price/GetPriceListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import PriceListFilters from './Components/PriceListFilters';
import { DeletePriceResponse } from '../../../models/response/price/DeletePriceResponse';
import { ExportPriceListResponse } from '../../../models/response/price/ExportPriceListResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadConstantsByCode, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const PriceList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Antrepo Modülü > Anlaşmalar > Fiyat Listesi"
    const pageVersion = "2";
    const [data, setData] = useState<GetPriceListPagingAndFilterResponseData>(initialGetPriceListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetPriceListPagingAndFilterRequest>(initialGetPriceListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Ad', name: 'name', order: 0, isVisible: true },
            { title: 'Ürün Cinsi', name: 'productKindName', order: 0, isVisible: true },
            { title: 'Kap Cinsi', name: 'potTypeName', order: 0, isVisible: true },
            { title: 'Çarpan 1', name: 'multiplier1Name', order: 0, isVisible: true },
            { title: 'Çarpan 2', name: 'multiplier2Name', order: 0, isVisible: true },
            { title: 'Birim Fiyat', name: 'unitPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'Min. Fiyat', name: 'minPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Açık Alan', name: 'isOpenArea', order: 0, isVisible: true },
            { title: 'Kapalı Alan', name: 'isClosedArea', order: 0, isVisible: true },
            { title: 'Isı Kontrollü Oda', name: 'isHeatControllerRoom', order: 0, isVisible: true },
            { title: 'Başlangıç Tarihi', name: 'startDateStr', order: 0, isVisible: true },
            { title: 'Bitiş Tarihi', name: 'endDateStr', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deletePrice = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.priceId);

            dispatch(storeActivityIndicator(true))

            var response: DeletePriceResponse = await PriceService.deletePrice(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updatePrice = async (_id: string | undefined = undefined) => {
        navigate('/price/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].priceId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetPriceListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetPriceListPagingAndFilterResponse = await PriceService.getPriceListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.priceId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportPriceListResponse = await PriceService.exportPriceList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.priceId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar.
    const sortableColumns = [
        'refNo', 'name', 'productKindName', 'potTypeName', 'multiplier1Name', 'multiplier2Name',
        'unitPrice', 'currencyTypeName', 'minPrice',
        'isOpenArea', 'isClosedArea', 'isHeatControllerRoom',
        'startDateStr', 'endDateStr', 'isCustomActive',
        'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (PriceManager.ApplyColumnFilters) aynı. Eski paneldeki "Depolama Yeri" seçimi
    // Açık Alan / Kapalı Alan / Isı Kontrollü Oda kolonlarının Evet/Hayır filtresinde.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        name: { type: 'text' },
        productKindName: { type: 'select', loadOptions: () => loadConstants('PRODUCT_KIND') },
        potTypeName: { type: 'select', loadOptions: () => loadConstants('POT_TYPE') },
        multiplier1Name: { type: 'select', loadOptions: () => loadConstants('MULTIPLIER_TYPE') },
        multiplier2Name: { type: 'select', loadOptions: () => loadConstants('MULTIPLIER_TYPE') },
        unitPrice: { type: 'number' },
        currencyTypeName: { type: 'select', loadOptions: () => loadConstantsByCode('CURRENCY') },
        minPrice: { type: 'number' },
        isOpenArea: YES_NO_FILTER,
        isClosedArea: YES_NO_FILTER,
        isHeatControllerRoom: YES_NO_FILTER,
        startDateStr: { type: 'date' },
        endDateStr: { type: 'date' },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetPriceListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.priceId)} onDoubleClick={() => updatePrice(item.priceId)}>
                    <a onClick={() => window.open(window.location.href + "add?id=" + item.priceId, "_blank")} href='javascript:;'>{item.refNo}</a>
                </td>
            )
        }
        else if (['isCustomActive', 'isOpenArea', 'isClosedArea', 'isHeatControllerRoom'].includes(column)) {
            var item3: any = item;
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.priceId)} onDoubleClick={!item.companyId ? undefined : () => updatePrice(item.priceId)}><StatusBadge text={item3[column] ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.priceId)} onDoubleClick={!item.companyId ? undefined : () => updatePrice(item.priceId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.priceId)} onDoubleClick={!item.companyId ? undefined : () => updatePrice(item.priceId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['unitPrice', 'minPrice'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.priceId)} onDoubleClick={!item.companyId ? undefined : () => updatePrice(item.priceId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.priceId)} onDoubleClick={!item.companyId ? undefined : () => updatePrice(item.priceId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <PriceListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deletePrice}
                    updateFunction={updatePrice}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input onChange={() => setItemSelected(item.priceId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default PriceList;